<template>
  <div class="container">
    <h2>{{ $t('livestock_outgoing') }}</h2>
    <!-- Movement Form Section -->
    <div>
      <!-- Save Button Moved to Top Right -->

      <div class="btn-update-cancel">
              <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80" type="submit" @click="saveMovementAndOutgoings">
                <i class="fas fa-save"></i> {{ movement.id ? $t('update') : $t('add') }}
              </button>
              <button class="btn btn-outline-secondary btn-sm me-2 btn-lg w-80" type="reset" @click="cancelAdd">
                <i class="bi bi-x"></i> {{ $t('cancel') }}
              </button>
      </div>

      <!--div class="text-end mb-2">
        <button @click="saveMovementAndOutgoings" class="btn btn-outline-success btn-sm me-2 btn-lg w-80">
          {{ movement.id ? $t('update') : $t('add') }}
        </button>
      </div-->
      <form @submit.prevent="saveMovementAndOutgoings" class="row g-3 align-items-center justify-content-between">

        <!-- Row 1: Destination, Date, Number -->
        <div class="form-group row">
          <label for="selectDestination" class="col-sm-2 text-start col-form-label">
            {{ $t('select_destination') }}
          </label>
          <div class="col-sm-4">
            <select id="selectDestination" v-model="movement.destination" class="form-control form-select" required>
              <option value="" disabled>-- {{ $t('select_destination') }} --</option>
              <option v-for="destination in destinations" :key="destination.id" :value="destination">
                {{ destination.value }}
              </option>
            </select>
          </div>
          <!-- Date -->
          <label for="selectDate" class="col-sm-1 text-start col-form-label">{{ $t('date') }}</label>
          <div class="col-sm-2">
            <input id="selectDate" v-model="movement.date" type="date" class="form-control" required />
          </div>
          <!-- Number -->
          <label for="inputNumber" class="col-sm-1 text-start col-form-label">{{ $t('input_number') }}</label>
          <div class="col-sm-2">
            <input id="inputNumber" v-model="movement.nombre" type="number" class="form-control" required />
          </div>
        </div>
        <!-- Row 2: Weight and Calculated Weight Per Unit -->
        <div class="form-group row">
          <label for="inputWeight" class="col-sm-2 text-start col-form-label">{{ $t('input_weight') }}</label>
          <div class="col-sm-4">
            <div class="input-group">
              <input id="inputWeight" v-model.number="movement.poidTot" type="number" class="form-control" required />
              <span class="input-group-text">kg</span>
            </div>
          </div>
          <label for="weightPerUnit" class="col-sm-2 text-start col-form-label">{{ $t('weight_per_unit') }}</label>
          <div class="col-sm-2">
            <div class="input-group">
              <input id="weightPerUnit" type="text" class="form-control" :value="formattedWeightPerUnit" disabled
                readonly />
              <span class="input-group-text">kg/1</span>
            </div>
          </div>
        </div>
        <!-- Row 3: Price and Calculated Price Per Unit -->
        <div class="form-group row">
          <label for="inputPrice" class="col-sm-2 text-start col-form-label">{{ $t('input_price') }}</label>
          <div class="col-sm-4">
            <div class="input-group">
              <input id="inputPrice" v-model.number="movement.prixTot" type="number" class="form-control" required />
              <span class="input-group-text">€</span>
            </div>
          </div>
          <label for="pricePerUnit" class="col-sm-2 text-start col-form-label">{{ $t('price_per_unit') }}</label>
          <div class="col-sm-2">
            <div class="input-group">
              <input type="text" id="pricePerUnit" class="form-control" :value="formattedPricePerUnit" disabled
                readonly />
              <span class="input-group-text">€/kg</span>
            </div>
          </div>
        </div>
        <!-- Row 4: Total Price -->
        <div class="form-group row">
          <!-- Total Price -->
          <label for="totalPrice" class="col-sm-2 text-start col-form-label">{{ $t('total_price') }}</label>
          <div class="col-sm-4">
            <div class="input-group">
              <input id="totalPrice" type="text" class="form-control" :value="formattedTotalPrice" disabled readonly />
              <span class="input-group-text">€</span>
            </div>
          </div>

          <!-- Operations Dropdown -->
          <label for="operations" class="col-sm-2 text-start col-form-label">{{ $t('operation') }}</label>
          <div class="col-sm-2">
            <select id="operations" v-model="movement.operation" class="form-control form-select" required>
              <option value="" disabled>-- {{ $t('select_operation') }} --</option>
              <option value="S">{{ $t("operations.S") }}</option>
              <option value="G">{{ $t("operations.G") }}</option>
              <option value="D">{{ $t("operations.D") }}</option>
            </select>
          </div>
        </div>
        <!-- Row 5: Remark -->
        <div class="form-group row">
          <label for="inputRemarque" class="col-sm-2 text-start col-form-label">{{ $t('input_remarque') }}</label>
          <div class="col-12 col-md-10 mt-3">
            <textarea id="inputRemarque" v-model="movement.remarque" class="form-control" rows="2"
              :placeholder="$t('input_remarque')"></textarea>
          </div>
        </div>
      </form>
    </div>

    <!-- Horizontal Section: DetailMovement List and Outgoing Table -->
    <div class="horizontal-container mt-2">
      <!-- Left: DetailMovement List -->
      <div class="detail-list">
        <h2>List of livestock</h2>
        <table class="custom-table">
          <thead>
            <!-- Filter Row -->
            <tr>
              <th></th>
              <th>
                <input v-model="filters.serialNumber" placeholder="Filter Serial Number" @input="applyFilters"
                  class="w-100" />
              </th>
              <th></th>
            </tr>
            <tr>
              <th></th>
              <th>Serial Number</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in filteredItems" :key="index">
              <td class="ml-2">
                <input class="border border-primary form-check-input" type="checkbox" v-model="selectedDetailIds"
                  :value="detail.id" />
              </td>
              <td>{{ detail.serialNumber }}</td>
              <td>{{ detail.unitPrice }}</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button @click="prevPage" :disabled="currentPage === 1" class="btn btn-outline-primary">
            ❮
          </button>
          <span>Page {{ currentPage }} of {{ totalPages }}</span>
          <button @click="nextPage" :disabled="currentPage >= totalPages" class="btn btn-outline-primary">
            ❯
          </button>
        </div>
      </div>

      <!-- Center: Add Button Positioned Between Tables -->
      <div class="add-button-container">
        <button @click="addSelectedToOutgoing" class="btn btn-outline-primary">
          <i class="bi bi-arrow-right-square"></i>
        </button>
      </div>

      <!-- Right: Outgoing Table -->
      <div class="outgoing-table">
        <h2>Livestock outgoing</h2>
        <table class="custom-table">
          <thead>
            <tr>
              <th><input v-model="filtersOutgoing.serialNumber" placeholder="Filter Serial"
                  @input="applyOutgoingFiltersT2" class="w-100" /></th>
              <th><input v-model="filtersOutgoing.value" placeholder="Filter Value" @input="applyOutgoingFiltersT2"
                  class="w-100" /></th>
              <!--th><input v-model="filtersOutgoing.date" placeholder="Filter Date" @input="applyOutgoingFiltersT2" class="w-100" /></th-->
              <th></th>
            </tr>
            <tr>
              <th>Serial Number</th>
              <th>Value</th>
              <!--th>Date</th-->
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(out, index) in paginatedOutgoing" :key="out.tempId">
              <td>{{ out.detailMovements.serialNumber }}</td>
              <td>{{ out.value }}</td>
              <!--td>{{ out.date }}</td-->
              <td>
                <button @click="removeOutgoing(index)" class="btn btn-outline-danger btn-sm">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Pagination Controls -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <button @click="prevPageT2" :disabled="currentOutgoingPage === 1" class="btn btn-outline-primary">
            ❮
          </button>
          <span>Page {{ currentOutgoingPage }} of {{ totalPagesT2 }}</span>
          <button @click="nextPageT2" :disabled="currentOutgoingPage >= totalPagesT2" class="btn btn-outline-primary">
            ❯
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "../libjs/alertService";
import {
  MovementService,
  DetailMovementsService,
  //OutgoingService,
  DestinationService
} from '@/api';

export default {
  name: 'MovementOut',
  data() {
    return {
      movement: {
        id: null,
        e_s: 'out',
        // Use destination only
        destination: null,
        date: null,
        nombre: null,
        poidTot: null,
        prixTot: null,
        remarque: "",
        outgoing: [],
        operation: 'S'
      },
      destinations: [],
      detailMovements: [],
      selectedDetailIds: [],
      pendingOutgoings: [],
      totalExpenses: 0,
      filters: {
        serialNumber: ""
      },
      currentPage: 1,
      itemsPerPage: 10, // Adjust number of rows per page
      outgoingItemsPerPage: 10,
      currentOutgoingPage: 1,
      filtersOutgoing: {
        date: "",
        value: "",
        serialNumber: ""
      },
    };
  },
  computed: {
    filteredItems() {
      return this.detailMovements
        .filter((detailMovement) => {
          return (
            this.filters.serialNumber.trim() === "" ||
            detailMovement.serialNumber.toLowerCase().includes(this.filters.serialNumber.toLowerCase())
          );
        })
        .slice(this.startIndex, this.endIndex);
    },
    filteredOutgoing() {
      return this.pendingOutgoings.filter(out => {
        return (
          (!this.filtersOutgoing.date || out.date.includes(this.filtersOutgoing.date)) &&
          (!this.filtersOutgoing.value || String(out.value).includes(this.filtersOutgoing.value)) &&
          (!this.filtersOutgoing.serialNumber || out.detailMovements.serialNumber.toLowerCase().includes(this.filtersOutgoing.serialNumber.toLowerCase()))
        );
      });
    },
    paginatedOutgoing() {
      return this.filteredOutgoing.slice(this.outgoingStartIndex, this.outgoingEndIndex);
    },
    totalPagesT2() {
      return Math.ceil(this.filteredOutgoing.length / this.outgoingItemsPerPage);
    },
    outgoingStartIndex() {
      return (this.currentOutgoingPage - 1) * this.outgoingItemsPerPage;
    },
    outgoingEndIndex() {
      return this.outgoingStartIndex + this.outgoingItemsPerPage;
    },
    totalPages() {
      return Math.ceil(this.detailMovements.length / this.itemsPerPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    endIndex() {
      return this.currentPage * this.itemsPerPage;
    },
    pricePerUnit() {
      if (this.movement.poidTot && this.movement.prixTot) {
        return this.movement.prixTot / this.movement.poidTot;
      }
      return 0;
    },
    weightPerUnit() {
      if (this.movement.poidTot && this.movement.nombre) {
        return this.movement.poidTot / this.movement.nombre;
      }
      return 0;
    },
    formattedPricePerUnit() {
      return this.pricePerUnit.toFixed(2);
    },
    formattedWeightPerUnit() {
      return this.weightPerUnit.toFixed(2);
    },
    totalPrice() {
      const price = this.movement.prixTot || 0;
      const expenses = this.totalExpenses || 0;
      return price + expenses;
    },
    formattedTotalPrice() {
      return this.totalPrice.toFixed(2);
    }
  },
  methods: {
    async fetchDestinations() {
      try {
        const response = await DestinationService.listDestination();
        this.destinations = response.data || response;
      } catch (error) {
        console.error('Failed to load destinations:', error);
      }
    },
    async fetchDetailMovements() {
      try {
        const response = await DetailMovementsService.getAllWhereNotInOutgoing();
        this.detailMovements = response.data || response;
      } catch (error) {
        console.error('Failed to load detail movements:', error);
      }
    },
    addSelectedToOutgoing() {
      if (this.selectedDetailIds.length === 0) {
        alert('No DetailMovements selected!');
        return;
      }

      this.selectedDetailIds.forEach((detailId) => {
        const detailObj = this.detailMovements.find(dm => dm.id === detailId);
        if (detailObj) {
          const alreadyAdded = this.pendingOutgoings.some(out =>
            //out.detailMovements.some(dm => dm.id === detailObj.id)
            out.detailMovements.id === detailObj.id
          );
          if (!alreadyAdded) {
            //const tempId = Date.now() + '-' + detailObj.id;
            const newOutgoing = {
              //tempId,
              date: new Date().toISOString().split('T')[0],
              value: detailObj.unitPrice,
              //detailMovements: [detailObj]
              detailMovements: detailObj /*{
                  id : detailObj.id,
                  serialNumber : detailObj.serialNumber
                }*/
            };
            this.pendingOutgoings.push(newOutgoing);
            //console.log('this.pendingOutgoings - ' + JSON.stringify(this.pendingOutgoings))              
          }
        }
      });
      this.updateList()
      this.selectedDetailIds = [];
    },
    async removeOutgoing(index) {
      this.pendingOutgoings.splice(index, 1);
      await this.fetchDetailMovements();
      this.updateList()
    },
    async saveMovementAndOutgoings() {
      if (!this.validateForm()) return;
      //console.log('this.movement' + JSON.stringify(this.movement))
      //console.log('this.pendingOutgoings' + JSON.stringify(this.pendingOutgoings))
      try {
        // Save or update the movement
        this.movement.outgoing = this.pendingOutgoings
        console.log('this.movement -->' + JSON.stringify(this.movement))

        if (this.movement.id) {
          await MovementService.updateMovementOutgoing(this.movement.id, this.movement);
          Message("success", this.$t("message.update_success"));
        } else {
          const response = await MovementService.createMovementOutgoing(this.movement);
          this.movement.id = response.id;
          Message("success", this.$t("message.add_success"));
        }
        // Save each pending outgoing
        /*for (const pending of this.pendingOutgoings) {
          const newOutgoing = {
            date: pending.date,
            value: pending.value,
            movement: { id: this.movement.id },
            detailMovements: pending.detailMovements.map(dm => ({ id: dm.id }))
          };
          await OutgoingService.createOutgoing(newOutgoing);
        }*/
        // Clear pending outgoings after saving
        //---this.pendingOutgoings = [];
        //--this.fetchDetailMovements();
        console.log('redirection')
        this.$router.push('/ListOfMovement');
      } catch (error) {
        Message("danger", this.$t("message.operation_failed"));
      }
    },
    cancelAdd() {
      console.log('cancelAdd')
      this.setMovementId(null)
      this.$router.push('/ListOfMovement');
    },
    validateForm() {
      if (!this.movement.destination) {
        Message("warning", this.$t("You need to fill all data of form"));
        return false;
      }
      if (!this.movement.date || !this.movement.nombre || !this.movement.poidTot || !this.movement.prixTot) {
        Message("warning", this.$t("You need to fill all data of form"));
        return false;
      }
      console.log('this.movement.nombre ' + this.movement.nombre)
      console.log('this.pendingOutgoings.length ' + this.pendingOutgoings.length)
      console.log('=== ' + (this.movement.nombre === this.pendingOutgoings.length))
      console.log('== ' + (this.movement.nombre == this.pendingOutgoings.length))
      if (this.movement.nombre !== this.pendingOutgoings.length) {
        Message("warning", this.$t(`Please add ${this.movement.nombre} livestocks at table`));
        return false
      }
      return true;
    },
    applyFilters() {
      this.currentPage = 1;
    },
    applyOutgoingFiltersT2() {
      this.currentOutgoingPage = 1;
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPageT2() {
      if (this.currentOutgoingPage > 1) this.currentOutgoingPage--;
    },
    nextPageT2() {
      if (this.currentOutgoingPage < this.totalPagesT2) this.currentOutgoingPage++;
    },
    updateList() {
      console.log('-updateList-')
      const filteredMovements = this.detailMovements.filter(movement =>
        !this.pendingOutgoings.some(outgoing => outgoing.detailMovements.serialNumber === movement.serialNumber)
      );
      this.detailMovements = filteredMovements
    }
  },
  mounted() {
    this.fetchDestinations();
    this.fetchDetailMovements();
  }
};
</script>

<style scoped>
.container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 10px;
}

h2 {
  background-color: #47c399;
  border-radius: 10px 10px 0 0;
  color: azure;
  padding: 3px;
  text-align: justify;
  padding-left: 15px;
}


/* Table Styles */
.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.custom-table thead tr {
  background-color: #f2f2f2;
}

.custom-table th .custom-table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.custom-table td {
  border: 1px solid #ddd;
  padding: 2px;
  text-align: justify;
  padding-left: 10px;
}

.custom-table tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table tbody tr:hover {
  background-color: #f1f1f1;
}

/* General Styling */
body,
input,
button {
  font-family: "Arial", sans-serif;
  font-size: 14px;
}

/* Form Styles */
form {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 15px;
  margin: 1px;
}

form input {
  flex: 1;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.input-group-text {
  font-size: 14px;
  background-color: #f8f9fa;
  border: 1px solid #ddd;
}

/* Remove arrows in Chrome, Safari, Edge, and Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

form button {
  font-size: 14px;
  padding: 8px;
  border-radius: 4px;
  border: none;
}

form button[type="submit"] {
  background-color: #28a745;
  color: #fff;
}

form button[type="reset"] {
  background-color: #6c757d;
  color: #fff;
}

form button:hover {
  opacity: 0.9;
}

/* Horizontal Container Styles */
.horizontal-container {
  display: flex;
  gap: 1rem;
  margin-top: 20px;
}

.detail-list {
  /*width: 30%;*/
  width: 30%;
}

.table {
  border: 1px solid darkgrey;
  text-align: justify;
}

.outgoing-table {
  /*width: 60%;*/
  width: 70%;
}
</style>